var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenseTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1885 7.92187C16.1885 7.11958 16.0305 6.32514 15.7234 5.58392C15.4164 4.8427 14.9664 4.1692 14.3991 3.60189C13.8318 3.03459 13.1583 2.58457 12.4171 2.27755C11.6758 1.97052 10.8814 1.8125 10.0791 1.8125V7.92187H16.1885Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92334 16.1875C8.72563 16.1875 9.52007 16.0295 10.2613 15.7225C11.0025 15.4154 11.676 14.9654 12.2433 14.3981C12.8106 13.8308 13.2606 13.1573 13.5677 12.4161C13.8747 11.6749 14.0327 10.8804 14.0327 10.0781H7.92334V3.96875C6.30303 3.96875 4.74909 4.61241 3.60336 5.75814C2.45763 6.90387 1.81396 8.45782 1.81396 10.0781C1.81396 11.6984 2.45763 13.2524 3.60336 14.3981C4.74909 15.5438 6.30303 16.1875 7.92334 16.1875Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseTracker);
export default __webpack_public_path__ + "static/media/expense-tracker.e9641912d6e280c21caf6b133faeda28.svg";
export { ForwardRef as ReactComponent };